import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Typography, Space, Spin, Grid, Tooltip, Divider, Switch, message, Dropdown, Modal, Input } from "antd";
import { ArrowLeftOutlined, InfoCircleOutlined, MailOutlined, PrinterOutlined, ShareAltOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { FilePdfOutlined } from "@ant-design/icons";

import SearchListAutoComplete from "../../components/SearchListAutoComplete";
import ReportDom from "../../components/common/ReportDom";
import { salesRecordWithDetailsApi, salesVoucherApi } from "../../apiservice/sales";

import SalesVoucherBody from "./components/SalesVoucherBody";
import SalesInsuranceVoucher from "./components/SalesInsuranceVoucher";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthInfo } from "../Auth/authSelectors";
import { fetchSingleInstitutionDetails } from "../../store/commonThunks/lookups";
import { downloadPdf } from "../../lib/functions";
import { generateInvoiceLinkApi, sendInvoiceEmailApi,  } from "../../apiservice/setting";
import ShareDocumentButton from "../../components/ShareButton/ShareDocumentButton";
import { useShareDocument } from "../../hooks/useShareDocument";
import SalesVoucherThermal from "./components/SalesVoucherThermal";

const { Text } = Typography;

const SalesVoucher = () => {
  const navigate = useNavigate();
  const reportRef = useRef(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [vouchersList, setVouchersList] = useState([]);
  const [data, setData] = useState(null);
  const [showStamp, setShowStamp] = useState(false);
  const [showSignature, setShowSignature] = useState(false); 
  const [showShipping, setShowShipping] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");


  const authInfo = useSelector(selectAuthInfo);
  const {institutionData} = useSelector((state) => state.lookups);  
  const types = [institutionData?.company_type,institutionData?.branch_company_type,];
const thermalEnabled = institutionData?.thermal_print === 'yes';
  const isPharmacyDrugStore = types.includes("Drug Store") || types.includes("Pharmacy");

  const {
  shareOpen,
  setShareOpen,
  email,
  setEmail,
  // loading,
  handleEmailShare,
  handleWhatsAppShare,
} = useShareDocument();


   

  const handleDownloadPDF = async () => {
    const saleId = selectedVoucher.sale_id;
    const voucherNo = data.sale_voucher_no;
    try {
    setPdfLoading(true);
  // downloadPdfFromRef(selectedVoucher.sale_id, `Invoice_${data.sale_voucher_no}.pdf`);
  await downloadPdf(`/print/sales/${saleId}`, `Invoice_${voucherNo}.pdf`);


 } catch (err) {
    console.error(err);
  } finally {
    setPdfLoading(false);
  }
};
const thermalRef = useRef(null);

const handleThermalPrint = useReactToPrint({
  contentRef: thermalRef,
  documentTitle: `Thermal_${data?.sale_voucher_no || "Receipt"}`,
  pageStyle: `
    @page { size: 112mm auto; margin: 0; }
    body { width: 112mm; margin: 0; padding: 0; }
  `,
});
const handleSendEmail = async () => {
  try {

    // generate once on server
    let res ;
    try{
    res = await generateInvoiceLinkApi({
      url: `/print/sales/${selectedVoucher.sale_id}`,
      fileName: `Invoice_${data.sale_voucher_no}.pdf`
    });
  }catch(err){
    console.log("generateinvoicelinkerr: ", err)
  }

    console.log("generateInvoiceLink res: ", res)

    await sendInvoiceEmailApi({
      email,
      name: data.acc_name,
      invoiceNo: data.sale_voucher_no,
      url: res?.url,
    });

    message.success("Invoice emailed");
    setShareOpen(false);
    setEmail("");

  } catch {
    message.error("Failed to send email");
  }
};


const handleWhatsApp = async () => {
  try {

    const res = await generateInvoiceLinkApi({
      url: `/print/sales/${selectedVoucher.sale_id}`,
      fileName: `Invoice_${data.sale_voucher_no}.pdf`
    });

    const text = `Hello ${data.acc_name},

Your Invoice ${data.sale_voucher_no} is ready.

Download here:
${res?.data?.url}

Regards,
${authInfo?.userInfo?.branch_name}`;

    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");

  } catch {
    message.error("Failed to share");
  }
};


  useEffect(() => {
    if (selectedVoucher?.sale_id) {
      salesRecordWithDetailsApi({ sale_id: selectedVoucher.sale_id, from: "voucher" }).then((res) => {
        if (res?.data?.length) setData(res.data[0]);
      });
    }
  }, [selectedVoucher?.sale_id]);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: `Sales Voucher-${data?.sale_voucher_no}`,
    removeAfterPrint: true,
  }); 

  useEffect(() => {
    const fetchVouchers = async () => {
      setLoading(true);
      try {
        const res = await salesVoucherApi({}); // fetch all vouchers
        setVouchersList(res.data || []);
      } catch {
        setVouchersList([]);
      } finally {
        setLoading(false);
      }
    };
    fetchVouchers();
    dispatch(fetchSingleInstitutionDetails());
  }, []);

  const hasBonusItems = data?.details?.some(
    (item) => Number(item.item_rate) === 0
  );

  useEffect(() => {
    if (shareOpen && customerEmail && !email) {
      setEmail(customerEmail);
    }
  }, [shareOpen, customerEmail, email, setEmail]);


  return (
    <div className="p-4">
      {/* Header Bar */}
      {/* Header Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/sales-dashboard")}>
          {!screens.xs && "Back"}
        </Button>

        <div style={{ flex: 1, maxWidth: screens.xs ? 200 : 400 }}>
          <SearchListAutoComplete
            entityType="voucher"
            placeholder="Voucher No"
            optionsList={(vouchersList || []).map((v) => ({
              sale_id: v.sale_id,
              display_text: v.display_text,
              raw: v,
            }))}
            style={{alignItems:"center"}}
            onSelect={(obj) => setSelectedVoucher(obj?.raw || null)}
            showAddNew={false}
            data-testid="sales-voucher"
          />
        </div>

        <Space align="center" wrap style={{ flex: screens.xs ? "1 1 100%" : "0 1 auto", rowGap: 8 }}>
          <Switch
            checked={showShipping}
            onChange={setShowShipping}
            checkedChildren="Shipping"
            unCheckedChildren="Shipping"
          />
          {!screens.xs && (
            <Switch
              checked={showStamp}
              onChange={setShowStamp}
              checkedChildren="Stamp"
              unCheckedChildren="Stamp"
            />
          )}

          <Switch
            checked={showSignature}
            onChange={setShowSignature}
            checkedChildren="Signature"
            unCheckedChildren="Signature"
          />

          <ShareDocumentButton
            disabled={!selectedVoucher}
            screens={screens}
            shareOpen={shareOpen}
            setShareOpen={setShareOpen}
            email={email}
            setEmail={setEmail}
            loading={loading}
            onEmail={() =>
              handleEmailShare({
                url: `/print/sales/${selectedVoucher.sale_id}`,
                fileName: `Invoice_${data.sale_voucher_no}.pdf`,
                name: data.acc_name,
                docNo: data.sale_voucher_no,
              })
            }
            onWhatsApp={() =>
              handleWhatsAppShare({
                url: `/print/sales/${selectedVoucher.sale_id}`,
                fileName: `Invoice_${data.sale_voucher_no}.pdf`,
                text: `Hello ${data.acc_name}, Your Invoice ${data.sale_voucher_no} is ready. Download here:`,
              })
            }
          />


          <Button
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={handleDownloadPDF}
            disabled={!selectedVoucher || pdfLoading }
            loading={pdfLoading}
          >
            {!screens.xs && "Download"}
          </Button>

          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            disabled={!selectedVoucher}
          >
            {!screens.xs && "Print"}
          </Button>
{thermalEnabled && (
  <Button
    icon={<PrinterOutlined />}
    onClick={handleThermalPrint}
    disabled={!selectedVoucher}
    style={{ background: "#1a1a1a", borderColor: "#1a1a1a", color: "#fff" }}
  >
    {!screens.xs && "Thermal"}
  </Button>
)}
          <Tooltip
            placement="bottom"
            title={
              <div style={{ maxWidth: 260 }}>
                <strong>Print Tip</strong>
                <div style={{ marginTop: 6 }}>
                  For best results, please disable
                  <b> “Headers and Footers”</b> in your browser’s print settings.
                </div>
              </div>
            }
          >
            <InfoCircleOutlined
              style={{
                color: "#888",
                fontSize: 16,
                cursor: "pointer",
              }}
            />
          </Tooltip>
        </Space>

      </div>


      {/* Voucher Display */}
      <Card className="shadow-md rounded-xl voucher-wrapper">
        {!selectedVoucher ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            {loading ? (
              <Spin />
            ) : (
              <Text type="secondary">Search and select a voucher</Text>
            )}
          </div>
        ) : !data ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <Spin />
          </div>
        ) : data.insurance_id ? (
          <>
          {/* PAGE 1 – Normal Insurance invoice (with bonus) */}
          <SalesInsuranceVoucher 
          key="insurance-invoice-with-bonus"
          sale_id={selectedVoucher.sale_id} 
          authInfo={authInfo} 
          setCustomerEmail={setCustomerEmail}
          showStamp={showStamp}
          showSignature={showSignature}
          showShipping={showShipping}/>
          {/* PAGE 2 – Without bonus Insurance Invoice (ONLY when required) */}
          {isPharmacyDrugStore && hasBonusItems && (
            <>
              <Divider />
              <SalesInsuranceVoucher
                key="insurance-invoice-without-bonus"
                sale_id={selectedVoucher.sale_id}
                authInfo={authInfo}
                setCustomerEmail={setCustomerEmail}
                hideBonusItems
                showStamp={showStamp}
                showSignature={showSignature}
                showShipping={showShipping}
              />
            </>
          )}
          </>

        ) : (
          <>
          {/* PAGE 1 – Normal invoice (with bonus) */}
          <SalesVoucherBody
            key="invoice-with-bonus"
            sale_id={selectedVoucher.sale_id}
            authInfo={authInfo}
            setCustomerEmail={setCustomerEmail}
            showStamp={showStamp}
            showSignature={showSignature}
            showShipping={showShipping}
          />

          {/* PAGE 2 – Without bonus (ONLY when required) */}
          {isPharmacyDrugStore && hasBonusItems && (
            <>
              <Divider />
              <SalesVoucherBody
                key="invoice-without-bonus"
                sale_id={selectedVoucher.sale_id}
                authInfo={authInfo}
                setCustomerEmail={setCustomerEmail}
                hideBonusItems
                showStamp={showStamp}
                showSignature={showSignature}
                showShipping={showShipping}
              />
            </>
          )}
        </>
        )}
      </Card>
     

      {/* Hidden print layout */}
      {selectedVoucher && (
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>        
          <ReportDom
            ref={reportRef}
            mode={showSignature ? "signatureOn": showStamp ? "signatureOn" : ""}
            // title="Sales Voucher"
            renderTable={() => (
              data?.insurance_id ? (
                <>
                <SalesInsuranceVoucher key="insurance-invoice-with-bonus" sale_id={selectedVoucher.sale_id} authInfo={authInfo} printMode showStamp={showStamp}
                showSignature={showSignature} showShipping={showShipping}/>
                {isPharmacyDrugStore && hasBonusItems && (
                    <>
                      <div style={{ pageBreakBefore: "always" }} />
                      <SalesInsuranceVoucher
                        key="insurance-invoice-without-bonus"
                        sale_id={selectedVoucher.sale_id}
                        authInfo={authInfo}
                        printMode
                        hideBonusItems
                        showStamp={showStamp}
                        showSignature={showSignature}
                        showShipping={showShipping}
                      />
                    </>
                  )}
                  </>
              ) : (
                <>
                  {/* FIRST PAGE: Normal invoice (WITH bonus items) */}
                  <SalesVoucherBody
                    key="invoice-with-bonus"
                    sale_id={selectedVoucher.sale_id}
                    authInfo={authInfo}
                    printMode
                    showStamp={showStamp}
                    showSignature={showSignature}
                    showShipping={showShipping}
                  />

                  {/* SECOND PAGE: Excluding bonus items (ONLY for pharmacy/drugstore) */}
                  {isPharmacyDrugStore && hasBonusItems && (
                    <>
                      <div style={{ pageBreakBefore: "always" }} />
                      <SalesVoucherBody
                        key="invoice-without-bonus"
                        sale_id={selectedVoucher.sale_id}
                        authInfo={authInfo}
                        printMode
                        hideBonusItems
                        showStamp={showStamp}
                        showSignature={showSignature}
                        showShipping={showShipping}
                      />
                    </>
                  )}
                </>
              )
            )}
          />
        </div>
      )}
{thermalEnabled && selectedVoucher && data && (
  <div   className="thermal-print-only" style={{ position: "absolute", left: "-9999px", top: 0 }}>
    <div ref={thermalRef}>
      <SalesVoucherThermal
        voucher={data}
        institution={institutionData}
        authInfo={authInfo}
        printMode
        hideBonusItems={false}
      />
      {isPharmacyDrugStore && hasBonusItems && (
        <>
          <div style={{ borderTop: "1px dashed #000", margin: "4px 0", pageBreakBefore: "always" }} />
          <SalesVoucherThermal
            voucher={data}
            institution={institutionData}
            authInfo={authInfo}
            printMode
            hideBonusItems
          />
        </>
      )}
    </div>
  </div>
)}
    </div>
  );
};

export default SalesVoucher;
